<template>
    <b-container>
        <h1 class="text-center pt-4 pb-4">{{ $t("title.keyClientManagement") }}</h1>

        <div class="mt-2" v-if="clientList.length > 0">
            <b-row class="pt-2">
                <b-col sm="4" class="mt-2">
                    <b-form-select v-model="perPage" :options="options"></b-form-select>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
                    <b-button variant="link" @click="resetTable()">{{ $t('action.reset') }}</b-button>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <div>{{ $t("label.tablesize") }} {{ rows }}</div>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col class="lgTable">
                    <b-table id="keyTable" stacked="lg" bordered :fields="myfields" :items="items" :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc" :per-page="perPage" :current-page="currentPage">
                        <template v-slot:cell(details)="row">
                            <b-button v-if="row.item.Status === 'active'" class="ml-2" size="sm" @click="openmodal('UpdateKeyForBuilding', row.item)">{{ $t("action.remove") }}</b-button>
                            <b-button v-else class="ml-2" size="sm" @click="openmodal('UpdateKeyForBuilding', row.item)">{{ $t("action.restore") }}</b-button>
                        </template>
                        <template v-slot:cell(Status)="row">
                            <b-button variant="link" size="sm" @click="openmodal('ViewKey', row.item)">{{ row.item.Status }}</b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col sm="6" class="mt-2">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                        aria-controls="keyTable"></b-pagination>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="mt-2">
                    <b-button variant="success" @click="openmodal('AddKeyForBuilding', null)">{{ $t("action.addANewKey")
                    }}</b-button>
                </b-col>
            </b-row>

            <b-modal size="xl" id="AddKeyForBuilding" :title="$t('action.addANewKey')" hide-footer>
                <AddKeyForBuilding modalid="AddKeyForBuilding" />
            </b-modal>

            <b-modal size="xl" id="UpdateKeyForBuilding" :title="$t('title.confirmation')" hide-footer>
                <UpdateKeyForBuilding :currentKey="currentValue" modalid="UpdateKeyForBuilding" />
            </b-modal>

            <b-modal size="xl" id="ViewKey" :title="$t('title.keyClientManagement')" hide-footer>
                <ViewKey :currentKey="currentValue" modalid="ViewKey" />
            </b-modal>
        </div>
        <div v-if="spinner" class="text-center">
            <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning"
                disabled="labelStatus"></b-spinner>
        </div>
        <div v-if="error" class="pt-4">
            <b-alert show variant="danger">
                <p>{{ error }}</p>
            </b-alert>
        </div>
    </b-container>
</template>
  
<script>
import axios from 'axios';
import { globalF } from '../../Helpers';
import AddKeyForBuilding from './AddKeyForBuilding.vue';
import UpdateKeyForBuilding from './UpdateKeyForBuilding.vue';
import ViewKey from './ViewKey.vue';

export default {
    mixins: [globalF],
    data() {
        return {
            error: "",
            sortBy: 'Source',
            sortDesc: false,
            perPage: 10,
            currentPage: 1,
            search: "",
            clientList: [],
            currentValue: null,
            options: [
                { value: 10, text: "10" },
                { value: 25, text: "25" },
                { value: 50, text: "50" },
                { value: 100, text: "100" },
            ],
            spinner: false
        }
    },
    mounted() {
        this.$root.$on('bv::modal::hide', () => {
            this.getAllClient();
        });
        
        this.getAllClient();
    },
    computed: {
        rows() {
            return this.items.length;
        },
        items: function () {
            let mydatalist = this.clientList;
            //return mydatalist;
            let search = this.search.toLowerCase();
            
            return mydatalist.filter(p => {

                let nocie = p.NOCIE ? p.NOCIE.toString().toLowerCase() : "";
                let nodiv = p.NODIV ? p.NODIV.toString().toLowerCase() : "";
                return nocie.includes(search) || nodiv.includes(search)
                || p.Source.toLowerCase().includes(search) || p.Client.toLowerCase().includes(search) || p.Status.toLowerCase().includes(search);

            });
        },
        myfields: function () {
            return [
                { key: 'Source', sortable: true, label: "Source" },
                { key: 'Client', sortable: true, label: "Client" },
                { key: 'Fields', sortable: true, label: "Fields" },
                { key: 'NOCIE', sortable: true, label: "NOCIE" },
                { key: 'NODIV', sortable: true, label: "NODIV" },
                { key: 'Status', sortable: true, label: "Status" },
                { key: 'details', label: this.$t('label.detail') }
            ]
        }
    },
    methods: {
        openmodal: function (id, value) {
            this.currentValue = value
            this.$bvModal.show(id);
        },
        getAllClient() {
            this.spinner = true;
            let urls = this.$store.getters.getUrlsList;
            let url = urls[process.env.VUE_APP_WHERE].json;

            let promise = this.validateToken();
            promise.then(() => {
                axios.post(url, { request: "getAllClient" }, { headers: { 'Content-Type': 'application/json' } })
                    .then((response) => {
                        this.spinner = false;
                        this.clientList = response.data;
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.error = this.$t('info.errorgeneric');
                    });
            });
        },
        resetTable: function () {
            this.$store.commit('setSearch', "");
            this.search = "";
            this.buildings = this.allBuilding;
        }
    },
    components: {
        AddKeyForBuilding,
        UpdateKeyForBuilding,
        ViewKey
    }
}
</script>
  